import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "card"
};
const _hoisted_2 = ["aria-expanded"];
const _hoisted_3 = ["href", "aria-controls"];
const _hoisted_4 = ["id", "aria-labelledby"];
const _hoisted_5 = {
  class: "card-body"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    role: "tab",
    class: _normalizeClass($props.isArrow ? 'card-header' : ''),
    "aria-expanded": $data.active,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.activate && $options.activate(...args))
  }, [_createElementVNode("a", {
    "data-toggle": "collapse",
    "data-parent": "#accordion",
    href: `#${$options.itemId}`,
    "aria-controls": `content-${$options.itemId}`
  }, [_renderSlot(_ctx.$slots, "title", {}, () => [_createTextVNode(_toDisplayString($props.title), 1)]), _cache[1] || (_cache[1] = _createElementVNode("i", {
    class: "tim-icons icon-minimal-down"
  }, null, -1))], 8, _hoisted_3)], 10, _hoisted_2), _withDirectives(_createElementVNode("div", {
    id: `content-${$options.itemId}`,
    role: "tabpanel",
    "aria-labelledby": $props.title,
    class: "collapsed"
  }, [_createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default")])], 8, _hoisted_4), [[_vShow, $data.active]])]);
}